import { ApolloQueryResult } from 'apollo-client';

import { findAndReplaceKeywordsPreview } from '../../graphql/queries/grid/common';
import { refinePhraseQuery } from '../../graphql/queries/grid/phrases-selector';
import { GroupType } from '../../typings/domain';
import {
    FindAndReplaceKeywordsPreview,
    GdFindAndReplaceKeywordsInput,
    RefinePhraseQuery
} from '../../typings/graphql-grid';
import { BaseDataProvider } from '../BaseDataProvider/BaseDataProvider';

export const previewLimitOffset = {
    limit: 60,
    offset: 0
};

export class PhrasesWizardDataProvider extends BaseDataProvider {
    public findAndReplaceKeywordsPreview(
        input: GdFindAndReplaceKeywordsInput,
        login: string
    ): Promise<FindAndReplaceKeywordsPreview> {
        input.limitOffset = previewLimitOffset;

        return this.createQuery<FindAndReplaceKeywordsPreview>(findAndReplaceKeywordsPreview, {
            variables: {
                input,
                login
            }
        }).then((result: ApolloQueryResult<FindAndReplaceKeywordsPreview>) => result.data);
    }

    public refinePhrase(
        keyword: string,
        geo: Array<number>,
        minusWords: Array<string>,
        adGroupType: GroupType,
        withExamples: boolean = false
    ): Promise<RefinePhraseQuery> {
        return this.createQuery<RefinePhraseQuery>(refinePhraseQuery, {
            variables: {
                input: {
                    geo,
                    minusWords,
                    keyword,
                    adGroupType
                },
                withExamples
            }
        }).then(result => result.data);
    }
}
